"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleWhiteboard = void 0;
var _reactUi = require("@100mslive/react-ui");
var _reactIcons = require("@100mslive/react-icons");
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _useWhiteboardMetadata = require("./useWhiteboardMetadata");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ToggleWhiteboard = function ToggleWhiteboard() {
  var _useWhiteboardMetadat = (0, _useWhiteboardMetadata.useWhiteboardMetadata)(),
    whiteboardEnabled = _useWhiteboardMetadat.whiteboardEnabled,
    whiteboardActive = _useWhiteboardMetadat.whiteboardOwner,
    amIWhiteboardOwner = _useWhiteboardMetadat.amIWhiteboardOwner,
    toggleWhiteboard = _useWhiteboardMetadat.toggleWhiteboard;
  if (!whiteboardEnabled) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Tooltip, {
    title: "".concat(whiteboardActive ? amIWhiteboardOwner ? "Stop whiteboard" : "Can't stop whiteboard" : "Start whiteboard"),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
      onClick: toggleWhiteboard,
      active: !whiteboardActive,
      disabled: whiteboardActive && !amIWhiteboardOwner,
      "data-testid": "white_board_btn",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PencilDrawIcon, {})
    })
  }, "whiteboard");
};
exports.ToggleWhiteboard = ToggleWhiteboard;